// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1lC4v","log":"ModalInventoryLogs_log__1jsbj","date":"ModalInventoryLogs_date__1oFLU","userName":"ModalInventoryLogs_userName__16Izd"};